export const apiUrl = 'https://self-service-api.mit-nonprod.ovotech.org.uk';
export const authTokenStorageKey = 'token';
